import NotePreferences from '@/modules/NotePreferences';
import style from './Settings.module.scss';
import Tabs from '@/components/Tabs';
import NoteTemplates from '@/modules/NoteTemplates';
import MainLayout from '@/components/MainLayout';
import { TemplateList } from '@/modules/TemplateList';
import {
  navigationSlice,
  selectCurrentSection,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';
import { SettingsPageSections } from '@ax/constants';
import Sidebar from '@/components/Sidebar';

function Settings() {
  const activeItem = useAppSelector(selectCurrentSection);
  const dispatch = useAppDispatch();

  const mainContentItems = [
    { id: SettingsPageSections.Preferences, title: 'Preferences', component: <NotePreferences /> },
    {
      id: SettingsPageSections.Templates,
      title: 'Templates',
      component: <NoteTemplates />,
    },
  ];

  return (
    <MainLayout
      sideBarContent={
        <Sidebar
          sideBarContent={activeItem === SettingsPageSections.Templates ? <TemplateList /> : null}
        />
      }
      mainContent={
        <div className={style.settings__container}>
          <Tabs
            activeItem={activeItem}
            onItemSelect={(section) => {
              dispatch(navigationSlice.actions.sectionNavigationRequested({ section }));
            }}
            items={mainContentItems}
          />
        </div>
      }
    />
  );
}

export default Settings;
